import React, {useEffect, useState} from 'react';
import {Sponsorship} from "types/Sponsorship";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {useOperator} from "context/OperatorContext";

type Props = {
    sponsorship: Sponsorship | null
    show: boolean
    onDelete?: (sponsorship: Sponsorship) => any
    onDeleteFail?: (sponsorship: Sponsorship, error: unknown) => any
    onCancel?: () => any
}

function DeleteSponsorship(props: Props) {
    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const {sponsorship, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(sponsorship?.name || 'this sponsorship ');
    const {mutateAsync: deleteSponsorship} = useMutation(ngage.sponsorships.destroy)

    useEffect(() => {
        if(sponsorship) setName(sponsorship.name)
    }, [sponsorship]);

    async function handleDeleteSponsorship() {
        if (sponsorship) {
            try {
                await deleteSponsorship(sponsorship.id)
                await invalidate('sponsorships.all')

                notify("success", `${termFor('Sponsorship')} Deleted`, `${sponsorship.name} has been permanently removed`)
                if (onDelete) onDelete(sponsorship)
            } catch (error) {
                notify("error", `${termFor('Sponsorship')} Not Deleted`, `${sponsorship.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(sponsorship, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Sponsorship')}`}
            body={`Are you sure you want to permanently delete ${termFor('sponsorship')} '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteSponsorship}
            onCancel={handleCancel}
        />
    );
}

export default DeleteSponsorship;